(function (ws) {
    'use strict';
    ws.views.resellerListingTable = ws.views.simpleTable.extend({

        /**
         * Constructor
         */
        initialize: function () {
            this.$table = this.$('#crl-reseller-table');
            this.$tableDiv = this.$('.crl-reseller-table-div');
            this.$recentTable = this.$('#recent-crl-reseller-table');
            this.$paginationShowing = this.$('.crl-pagination-showing');
            this.rowTemplate = this.$('#crl-reseller-table-row');
            this.rowTemplateRecent = this.$('#crl-recent-reseller-table-row');
            this.$tbodyRecent = this.$recentTable.children('tbody');
            this.paginateUrl = globals.path.api.westcon.getResellerList;
            this.searchHeaderTitle = this.$('.searchHeaderTitle');
            this.$pagination = this.$('.pagination');
            this.$apiError = this.$('.api-error-message');
            this.controlColumn = 0;
            this.$form = this.$('.crl-form');
            this.searchTemplate = _.template(this.$('#crl-form-inputs').html());
            this.successTemplate = _.template(this.$('#crl-form-success').html());
            this.$error = this.$('.error-message');
            this.$headerNav = $('.hed-primary-navigation');
            this.$headerMinicart = $('.hed-minicart');
            this.$headerBreadcrumbs = $('.comp-breadcrumbs');
            this.$selectedCountry = '';
            this.$selectedLanguage = '';
            this.$selectedCurrency = '';
            this.responsivePriority = [
                {responsivePriority: 1, targets: 0},
                {responsivePriority: 1, targets: 1},
                {responsivePriority: 1, targets: 2},
                {responsivePriority: 1, targets: 3},
                {responsivePriority: 2},
                {responsivePriority: 2},
                {responsivePriority: 2},
                {responsivePriority: 2},
                {responsivePriority: 2}
            ];
            this.modifyHeader();
            ws.views.simpleTable.prototype.initialize.call(this);
            this.$recentTable.css('visibility', 'visible');
            this.initializeForm();
            this.searchHeaderTitle.hide();
            this.$tableDiv.hide();
            this.enableForm();
            $('.qut-sap-block-msg-cancel').on('click', this.unSetSearchQuery.bind(this));

            $(document).on('click', '.qut-sap-block-msg-continue', (event) => {
                if (event.ctrlKey || event.metaKey || event.button === 1) {
                    return;
                }

                event.preventDefault();
                globals.disableApp();
                setTimeout(() => {
                    window.location.href = $(event.target).parent().attr('href');
                }, 500);
            });
        },

        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'click .crl-submit': 'searchFilter',
            'click .crl-reset': 'resetFilter',
            'change [name=crl-country]': 'onCountryChange',
            'change [name=crl-language]': 'onLanguageChange',
            'change select': 'enableForm',
            'click [data-switch-id]': 'switchStore'
        }),

        /**
         * Override search callback
         * @param {Object} ev - Event object
         */
        search: function (ev) {
            if (ev.which === 13) {
                ev.preventDefault();
                if ((ev.target.value) && ($('select[name="crl-country"]').val() != '')) {
                    this.searchFilter();
                }
            }
        },

        /**
         * Resetting the search
         */
        unSetSearchQuery: function () {
            $('.crl-reset').trigger('click');
        },

        /**
         * If this view is rendered, the header should not contain navigation and cart, so remove them from DOM
         */
        modifyHeader: function () {
            this.$headerNav.remove();
            this.$headerMinicart.remove();
            this.$headerBreadcrumbs.remove();
        },

        /**
         * Search for resellers based on submitted filters
         */
        searchFilter: function () {
            this.$error.hide();
            this.$apiError.hide();

            this.$selectedCountry = this.$country.val();

            var request = {
                country: this.$country.val(),
                searchText: this.$reseller.val()
            };

            var model = new ws.models.resellerListingModel();

            model.fetch({
                data: request
            }).done(function (response) {
                if (response.data && response.data.length > 0) {

                    dataLayerAA.search = {};
                    dataLayerAA.search.type = 'resellers';
                    dataLayerAA.search.country = request.country;
                    dataLayerAA.search.query = request.searchText;
                    _satellite.track('event:search');

                    this.$form.html(this.successTemplate({
                        country: $.trim(this.$country.find('option:selected').text()),
                        reseller: this.$reseller.val()
                    }));
                    this.$tableDiv.show();
                    this.$table.dataTable().fnClearTable();
                    this.$table.DataTable().destroy();
                    this.calculateShowing(response.paginationData);
                    this.calculatePagination(response.paginationData);
                    this.renderRows(response.data);
                    this.$table.css('visibility', 'visible');
                    this.$paginationShowing.show();
                    this.searchHeaderTitle.show();
                    if (response.recentViewData.length > 0) {
                        this.eventAgg.trigger('comp-updage-recentreseller', response.recentViewData);
                        this.$recentTable.css('visibility', 'visible');
                        $('#tbl-simple-showing-results').show();
                    }
                } else {
                    this.$error.show();
                }
            }.bind(this)).fail(function() {
                this.$apiError.show();
            }.bind(this));
            this.paginateUrl = globals.path.api.westcon.getResellerList + '?country=' + this.$country.val() + '&searchText=' + this.$reseller.val();
        },

        /**
         * Get account info and populate dropdowns
         */
        initializeForm: function () {
            this.$form.html(this.searchTemplate());
            this.$country = this.$('[name=crl-country]');
            this.$reseller = this.$('[name=crl-reseller-name]');
            this.$submit = this.$('.crl-submit');
        },

        /**
         * Get currencies based on country selection
         */
        onCountryChange: function (ev) {
            const $el = $(ev.currentTarget);
            const model = new ws.models.resellerAccountModel({
                code: $el.val()
            });
            this.$apiError.hide();

        },

        /**
         * Update selected Language
         */
        onLanguageChange: function () {
            const setCountryAndLanguageUrl = globals.path.api.westcon.setCountryAndLanguage + '?salesOrg=' + westconCurrentCountry + '&language=' + this.$language.val();
            $('#change-language-error-message').hide();
            $.ajax({
                url: setCountryAndLanguageUrl,
                data:'',
                contentType: 'application/json',
                dataType: 'json'
            }).done(function (response) {
                if (!response) {
                    if (this.$language.val()) {
                        $('#change-language-error-message').show();
                    }
                }
            }.bind(this)).fail(function () {
                this.$currency.prop('disabled', false);
                this.$language.prop('disabled', false);
                $('#change-language-error-message').show();
            }.bind(this));
        },

        /**
         * Populate Currency dropdown with API values
         * @param {Array} currencyList
         */
        populateCurrencyDropdown (currencyList) {
            this.resetCurrency();
            _.each(currencyList, function (currency) {
                this.$currency.append('<option>' + currency + '</option>');
            }.bind(this));
            this.$currency.prop('disabled', false);
        },

        /**
         * Populate Language dropdown with API values
         * @param {Array} languageList
         */
        populateLanguageDropdown (languageList) {
            this.$language.find('option:not(:first-child)').remove();
            _.each(languageList, function (language) {
                if (language.selected) {
                    this.$language.append('<option selected="selected" value="' + language.isocode + '">' + language.name + '</option>');
                } else {
                    this.$language.append('<option value="' + language.isocode + '">' + language.name + '</option>');
                }
            }.bind(this));
            this.$language.prop('disabled', false);
        },

        /**
         * Calculate pagination based on new results
         * @param {Object} pagination
         */
        calculatePagination: function (pagination) {
            //only show pagination if multiple pages of results
            if (pagination.numberOfPages === 1 || pagination.totalNumberOfResults === 0) {
                this.$pagination.hide();
            } else {
                //generate in between <li>
                this.$pagination.show();

                var currentPageNumber = pagination.currentPage;
                var totalNumberPages = pagination.numberOfPages;

                var prevPage = currentPageNumber === 0 ? currentPageNumber : currentPageNumber - 1;
                var nextPage = currentPageNumber + 1;
                var firstArrow = '<li class="pagination-first-arrow" > <a href="&page=' + prevPage + '" class="arrow">&lt;</a> </li>';
                var lastArrow = '<li class="pagination-last-arrow"> <a href="&page=' + nextPage + '" class="arrow">&gt;</a> </li>';
                var numberClass;
                var page;

                var totalNavShow = 5;
                var miniNavShow = totalNavShow / 2;

                //calculating the start/end of pagination when more than 5 results
                var begin = ((currentPageNumber - miniNavShow) > 0 ? ((currentPageNumber - miniNavShow) < (totalNumberPages - totalNavShow + 1) ? (currentPageNumber - miniNavShow) : (totalNumberPages - totalNavShow)) : 0) + 1;
                var end = (currentPageNumber + miniNavShow) < totalNumberPages ? ((currentPageNumber + miniNavShow) > totalNavShow ? (currentPageNumber + miniNavShow) : totalNavShow) : totalNumberPages;

                this.$pagination.html('');
                if (totalNumberPages < 6) {
                    for (var i = 1; i <= pagination.numberOfPages; i++) {
                        numberClass = currentPageNumber === (i - 1) ? 'current' : '';
                        this.$pagination.append('<li><a href="&page=' + (i - 1) + '" data-page=" ' + i + ' " class="' + numberClass + '">' + i + '</a></li>');
                    }
                } else if (totalNumberPages > 5) {
                    for (var j = begin; j <= end; j++) {
                        numberClass = currentPageNumber === (Math.round(j) - 1) ? 'current' : '';
                        this.$pagination.append('<li><a href="&page=' + (Math.round(j) - 1) + '" data-page=" ' + Math.round(j) + ' " class="' + numberClass + '">' + Math.round(j) + '</a></li>');
                    }
                }

                if (currentPageNumber === 0 && totalNumberPages > 5) {

                    //if on the first page
                    this.$pagination.append(lastArrow);
                } else if ((currentPageNumber + 1 === totalNumberPages) && totalNumberPages > 5) {

                    //if on the last page
                    this.$pagination.prepend(firstArrow);
                } else if (totalNumberPages > 5) {

                    //if on any page in between
                    this.$pagination.prepend(firstArrow);
                    this.$pagination.append(lastArrow);
                }
            }
        },
        /**
         * Check form state and enable submit button when all select fields are filled in
         */
        enableForm: function () {
            var empty = false;

            this.$form.find('select').each(function () {
                if ($(this).val() === '') {
                    empty = true;
                }
            });

            this.$submit.prop('disabled', empty);
        },

        /**
         * Switch store to a selected reseller
         * @param {Object} ev - Event object
         */
        switchStore: function (ev) {
            ev.preventDefault();
            const $el = $(ev.currentTarget);
            const hasBlockMessage = $el.data('blockmessage');
            let url = globals.path.api.westcon.switchStore +
                '?userGroupId=' + $el.data('switch-id') +
                '&code=' + $el.data('switch-salesorg') +
                '&language=' + this.$selectedLanguage +
                '&currency=' + this.$selectedCurrency;

            if (hasBlockMessage) {
                this.eventAgg.trigger('qut-sap-block-msg-modal');
                $('.qut-sap-block-msg-continue').attr('href', url);
            } else {
                globals.disableApp();
                window.location.href = url;
            }
        },

        /**
         * Clear currency input
         */
        resetCurrency: function () {
            this.$currency.find('option:not(:first-child)').remove();
        },

        /**
         * Reset the view, filters and the table
         */
        resetFilter: function () {
            this.$error.hide();
            this.initializeForm();
            this.$table.dataTable().fnClearTable();
            this.$table.DataTable().destroy();
            this.$table.css('visibility', 'hidden');
            this.$tableDiv.hide();
            this.$paginationShowing.hide();
            this.searchHeaderTitle.hide();
            this.enableForm();
        }
    });

}(westcon));
